import { BrowserUtility } from '@utility/browser-utility';
import { APIPath } from '@utility/constants/api';
import { CommonConstant } from '@utility/constants/common';
import { DateUtility } from '@utility/date';
import { BaseService } from './base';

class Metadata {
  get = async () => {
    const metadata = this.getLocally();
    if (metadata) {
      return metadata;
    }
    const result = await BaseService.localFiles('/metadata.json');
    const ipInfo = await BaseService.fetchIpInfo(false);

    this.saveLocally(result, { ipInfo });
    return result;
  };

  getLocally = () => {
    const metadata = BrowserUtility.getObj(CommonConstant.metadata);
    if (metadata) {
      if (DateUtility.isDateAfter(new Date(metadata.valid), new Date())) {
        return metadata.items;
      }
    }
    return null;
  };

  saveLocally = (items, { ipInfo }) => {
    const data = {
      items,
      valid: DateUtility.addDays(new Date(), 1),
    };
    BrowserUtility.saveObj(CommonConstant.metadata, data);
    BrowserUtility.save(CommonConstant.ipAddress, ipInfo);
  };

  orgMetadata = () => BaseService.get(APIPath.orgMetadata);
}

const MetadataService = new Metadata();
Object.freeze(MetadataService);
export default MetadataService;
